import React, { Suspense, lazy } from 'react';
import { createBrowserRouter } from 'react-router-dom';
import { Spinner, Center } from '@chakra-ui/react';
import { AccessDetailsProvider } from './features/auth/accessProvider';

const Dashboard = lazy(() => import('./App'));
const ErrorPage = lazy(() => import('./components/Error/error-page'));
const LandingPage = lazy(() => import('./landingpage2/index'));

const FullScreenLoader = () => (
  <Center minH="100vh">
    <Spinner size="xl" />
  </Center>
);

// Create the router
export const router = createBrowserRouter([
  {
    path: '/',
    element: (
      <Suspense fallback={<FullScreenLoader />}>
        <LandingPage />
      </Suspense>
    ),
    errorElement: (
      <Suspense fallback={<FullScreenLoader />}>
        <ErrorPage />
      </Suspense>
    ),
  },
  {
    path: '/dashboard',
    element: (
      <AccessDetailsProvider>
        <Suspense fallback={<FullScreenLoader />}>
          <Dashboard />
        </Suspense>
      </AccessDetailsProvider>
    ),
  },
]);
